import React from 'react';
import { ReactComponent as SgbnetIcon } from 'assets/icons/sgbnet.svg';
import { ReactComponent as WarningIcon } from 'assets/icons/big-warning.svg';
import ButtonComponent from '../button/buttonComponent';
import Footer from '../footer/footerComponent';

interface ErrorBoundaryState {
  hasError: boolean;
  error?: Error;
}

class ErrorBoundary extends React.Component<
  React.PropsWithChildren,
  ErrorBoundaryState
> {
  constructor(props: React.PropsWithChildren) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('Error caught by ErrorBoundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="w-screen h-screen bg-base-content">
          <div className="w-full flex items-center justify-center py-9 bg-white border-b shrink-0 p-0">
            <SgbnetIcon className="h-5 w-40 min-h-[20px]" />
          </div>
          <div className="relative h-[calc(100%_-_180px)]">
            <div className="absolute flex flex-col top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
              <div className="flex flex-col items-center justify-center gap-2.5 text-neutral-800">
                <WarningIcon className="w-16 h-16 max-w-[4rem]" />
                <div className="text-h3 text-neutral-800 font-semibold text-center">
                  <p>Oops...something went wrong</p>
                  <p>Please try again later</p>
                </div>
              </div>
              <ButtonComponent
                onClick={() => window.location.reload()}
                testID="retry"
                className="!w-fit !text-sm mt-8 mx-auto"
              >
                Retry
              </ButtonComponent>
            </div>
          </div>
          <Footer type="default" />
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
